// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"_299jnI","left":"_1fEgXm","right":"_1h9qMJ","opened":"_3U-mIZ","content":"_3Aaqt8"};